// @flow

import * as React from 'react';
import OlMap from 'ol/map';
import proj from 'ol/proj';
import { translate } from "react-i18next";
import customControl from './../popups/customControl';
import centerIcon from '../../../../icons/center.png';
import loading from './../../../../utilities/loading';
import messageManager from './../../../../utilities/messageManager';

type State = {
}

type Props = {
    olMap: OlMap,
    centerMap: (Array<number>)=> void,
    t: (s: string) => string,
};

export class CenterViewButton extends React.Component<Props, State> {
    centerViewControl: customControl;

    onCenterViewClick(context: CenterViewButton) {
        if (navigator.geolocation) {
            loading.start();
            navigator.geolocation.getCurrentPosition(
                position => {
                    const { longitude, latitude } = position.coords;
                    const transformedCoords = proj.transform([longitude, latitude], "EPSG:4326", "EPSG:3857");
                    context.props.centerMap(transformedCoords);
                    loading.stop();
                },
                error => {
                    messageManager.show({
                        type: 'error',
                        text: context.props.t('Cannot get location'),
                    });
                    loading.stop();
                },
                {
                    enableHighAccuracy: false,
                    timeout: 4000,
                    maximumAge: 3600000,
                }
            )
        }
    }

    constructor(props: Props) {
        super();
        const { t } = props;
        this.centerViewControl = new customControl({
            onClick: this.onCenterViewClick,
            className: 'ol-center-view-button',
            title: t('Center map'),
            innerHTML: '<img width="20px" height="20px" src=' + centerIcon + '></img>',
            parent: this
        });
        props.olMap.addControl(this.centerViewControl);
    }

    componentDidUpdate(): void {
        const { t } = this.props;
        this.centerViewControl.ref.title = t('Center map');
      }
    

    render(): React.Node {
        return false;
    }
};

export default translate("translations")(CenterViewButton);



// WEBPACK FOOTER //
// ./src/containers/content/map/centerViewButton/CenterViewButton.jsx